import React from 'react';
import { Provider } from 'react-redux';
import persistStore from 'redux-persist/es/persistStore';

import App from './App';
import { store } from './store';

export const AppWrapper = () => {
  persistStore(store);
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};
